module.exports = __webpack_public_path__ + "media/base/builder_small-6b8c6c35.svg";